module.exports = __webpack_public_path__ + "/img/308da3e6b6d3af0edf6e6624b5ed8bc8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/post-option.png
 ** module id = 23
 ** module chunks = 0 1 2 3 4 5
 **/